<template>
  <v-container class="pa-0 ma-0">
    <v-container class="pa-0 ma-0">
      <v-row class="pa-0 ma-0">
        <v-col cols="4" class="py-0 d-flex flex-nowrap">
          <v-icon
            style="display: inline-block; margin: 0px 5px;"
            class="pl-2 py-1"
            >mdi-sort-variant</v-icon
          >

          <v-select
            dense
            v-model="selectedSortOption"
            :items="sortingOptions"
            item-text="text"
            item-value="id"
            label="Select"
            return-object
            single-line
            v-on:change="changeSorting"
            class="py-0 pl-1"
          ></v-select>
        </v-col>
        <v-col cols="4"></v-col>
        <v-col cols="4" class="py-0">
          <v-text-field
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="поиск"
            single-line
            hide-details
            class="py-0 pr-2"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-data-table
      dense
      :headers="headers"
      :items="countries"
      item-key="id"
      :items-per-page="-1"
      :group-by="groupByMethod"
      :sort-by="sortMethod"
      :search="search"
      :custom-filter="customSearch"
      hide-default-footer
      hide-default-header
      :loading="loading"
      :custom-sort="customSort"
      class="elevation-1"
    >
      <template v-slot:body="{ items, groupedItems }">
        <tbody>
          <tr v-if="loading">
            <td class="text-center">Загружаем путешествия...</td>
          </tr>
          <template v-for="gitem in groupedItems">
            <tr :key="gitem.name" class="hidden-xs-only">
              <td
                colspan="3"
                class="primary font-weight-black white--text text-left py-2 my-5"
              >
                <CountriesTableCountryNameRow
                  :country-name="gitem.items[0].country_name"
                  :country-code="gitem.items[0].country_code"
                  :countries-visited="
                    countriesVisited[filterByPersonIds].visits[
                      gitem.items[0].country_name
                    ]
                  "
                  :nights-spent="
                    countriesVisited[filterByPersonIds].nights[
                      gitem.items[0].country_name
                    ]
                  "
                ></CountriesTableCountryNameRow>
              </td>
            </tr>

            <tr
              v-for="item in gitem.items"
              :key="item.id"
              class="hidden-xs-only"
            >
              <td style="vertical-align: top; width: 50px">
                {{ item.travel_year }}
              </td>
              <td style="vertical-align: top; width: 260px">
                <VisitDates
                  :in-date="item.in_date"
                  :out-date="item.out_date"
                  :in-transport="item.in_transport"
                  :out-transport="item.out_transport"
                  :visit-duration="item.duration"
                  horizontal
                ></VisitDates>
                <PersonAvatar
                  v-for="person in item.persons"
                  :key="person.id"
                  :avatar-filename="person.avatar_filename"
                  avatar-height="25px"
                  class="pb-5 pt-3"
                ></PersonAvatar>
              </td>
              <td style="vertical-align: top;">
                <span
                  >{{ item.journey_description }} {{ item.description }}</span
                >
                <span>/</span>
                {{ item.journey_name }}
                <span>/</span>
              </td>
            </tr>
          </template>
          <template v-for="gitem in groupedItems">
            <tr :key="'m' + gitem.name" class="hidden-sm-and-up">
              <td
                class="primary font-weight-black white--text text-left py-2 my-5 px-1 mx-1"
              >
                <CountriesTableCountryNameRow
                  :country-name="gitem.items[0].country_name"
                  :country-code="gitem.items[0].country_code"
                  :countries-visited="
                    countriesVisited[filterByPersonIds].visits[
                      gitem.items[0].country_name
                    ]
                  "
                  :nights-spent="
                    countriesVisited[filterByPersonIds].nights[
                      gitem.items[0].country_name
                    ]
                  "
                ></CountriesTableCountryNameRow>
              </td>
            </tr>

            <tr
              v-for="item in gitem.items"
              :key="'m' + item.id"
              class="hidden-sm-and-up"
            >
              <td class="px-1">
                <v-container class="ma-0 pa-0">
                  <v-row class="flex-wrap ma-0 pa-0">
                    <v-col cols="3" class="ma-0 pa-0">{{
                      item.travel_year
                    }}</v-col>
                    <v-col cols="9" class="ma-0 pa-0 text-right">
                      <VisitDates
                        :in-date="item.in_date"
                        :out-date="item.out_date"
                        :in-transport="item.in_transport"
                        :out-transport="item.out_transport"
                        :visit-duration="item.duration"
                        horizontal
                      ></VisitDates>
                    </v-col>
                    <v-col cols="12" class="ma-0 pa-0 text-right">
                      <PersonAvatar
                        v-for="person in item.persons"
                        :key="person.id"
                        :avatar-filename="person.avatar_filename"
                        avatar-height="25px"
                        class="pb-5 pt-3"
                      ></PersonAvatar>
                    </v-col>
                    <v-col cols="12" class="ma-0 pa-0 pb-4 text-left">
                      <span class="font-weight-light">
                        {{ item.journey_description }}
                        {{ item.description }}
                      </span>
                      <span>/</span>

                      <span>/</span>
                    </v-col>
                  </v-row>
                </v-container>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import VisitDates from '@/components/VisitDates'

import PersonAvatar from '@/components/PersonAvatar'
import CountriesTableCountryNameRow from '@/components/CountriesTableCountryNameRow'

export default {
  components: {
    VisitDates,
    PersonAvatar,
    CountriesTableCountryNameRow
  },

  props: {
    countries: {
      type: Array,
      required: true
    },
    filterByPersonIds: {
      type: Number,
      default: 0
    },
    countriesVisited: {
      type: Object
    }
  },

  data() {
    return {
      selectedSortOption: { text: 'по алфавиту', id: 'country_name' },
      sortingOptions: [
        { text: 'по алфавиту', id: 'country_name' },
        { text: 'по количеству поездок', id: 'visits_number' },
        { text: 'по количеству дней', id: 'days_number' }
      ],

      headers: [
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'country_name'
        },
        {
          text: '',
          value: 'travel_year',
          sortable: false,
          align: 'start'
        },

        {
          text: '',
          value: 'persons',
          filter: value => {
            if (!this.filterByPersonIds || this.filterByPersonIds == 0)
              return false
            return value.map(x => x.id).includes(this.filterByPersonIds)
          },
          sortable: false,
          width: '160px'
        },
        {
          text: '',
          value: 'description',

          sortable: false,
          align: 'start'
        }
      ],
      search: '',
      loading: true,
      groupByMethod: 'country_name',
      sortMethod: 'country_name'
    }
  },
  updated() {
    this.loading = false
  },

  methods: {
    changeSorting() {
      this.sortMethod = this.selectedSortOption.id
    },

    customSort(items, index) {
      items.sort((a, b) => {
        if (index[1] == 'country_name')
          return a.country_name.localeCompare(b.country_name)
        if (index[1] == 'visits_number') {
          var ca =
            this.numberToStringWithLeadingZeros(
              this.countriesVisited[this.filterByPersonIds].visits[
                a.country_name
              ],
              4
            ) + a.country_name
          var cb =
            this.numberToStringWithLeadingZeros(
              this.countriesVisited[this.filterByPersonIds].visits[
                b.country_name
              ],
              4
            ) + b.country_name

          return cb.localeCompare(ca)
        }
        if (index[1] == 'days_number') {
          ca =
            this.numberToStringWithLeadingZeros(
              this.countriesVisited[this.filterByPersonIds].nights[
                a.country_name
              ],
              4
            ) + a.country_name
          cb =
            this.numberToStringWithLeadingZeros(
              this.countriesVisited[this.filterByPersonIds].nights[
                b.country_name
              ],
              4
            ) + b.country_name

          return cb.localeCompare(ca)
        }
      })
      return items
    },

    customSearch(value, search, item) {
      value = value + 1 //я не зннаю как не иметь value в паарметрах метода, а если он там есть то его надо использовать
      if (search.length < 3) return true
      if (item.country_name.toLowerCase().includes(search.toLowerCase()))
        return true
      if (
        item.description &&
        item.description.toLowerCase().includes(search.toLowerCase())
      )
        return true
      if (
        item.journey_description &&
        item.journey_description.toLowerCase().includes(search.toLowerCase())
      )
        return true
      if (item.journey_name.toLowerCase().includes(search.toLowerCase()))
        return true

      return false
    },

    numberToStringWithLeadingZeros(number, order) {
      return ('000000000' + number).substr(-1 * order)
    }
  }
}
</script>

<style></style>
